import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
} from "reactstrap";
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  },
}));

function ArticulosCreateSolo() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_MARCAS = process.env.REACT_APP_URL_MARCAS;
  const URL_COLECCIONES = process.env.REACT_APP_URL_COLECCIONES;
  const URL_COLORES = process.env.REACT_APP_URL_COLORES;
  const URL_TALLAS = process.env.REACT_APP_URL_TALLAS;
  const URL_CATALOGO_PROCESOS = process.env.REACT_APP_URL_CATALOGO_PROCESOS;
  // const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  // const URL_COMPRADORES = process.env.REACT_APP_URL_COMPRADORES;
  // const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_DEPARTAMENTOS = process.env.REACT_APP_URL_DEPARTAMENTOS;
  const URL_SUBDEPARTAMENTOS = process.env.REACT_APP_URL_SUBDEPARTAMENTOS;
  // const URL_CLASES = process.env.REACT_APP_URL_CLASES;
  // const URL_SUBCLASES = process.env.REACT_APP_URL_SUBCLASES;
  const URL_EMPRESAS = process.env.REACT_APP_URL_EMPRESAS;
  const URL_TELAS = process.env.REACT_APP_URL_TELAS;
  const URL_EXPLOSION = process.env.REACT_APP_URL_EXPLOSION;
  const URL_HABILITACION = process.env.REACT_APP_URL_HABILITACION;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");
  const [fecha, setFecha] = useState(hoy);

  const [articulosGuardado, setArticulosGuardado] = useState([]);
  const [codigo, setCodigo] = useState("");
  const [pedido, setPedido] = useState("NA");
  const [codigoCliente, setCodigoCliente] = useState("NA");
  const [nombre, setNombre] = useState("");
  const [descripcion, setDescripcion] = useState("NA");
  const [codigoSAT, setCodigoSAT] = useState("NA");
  const [observaciones, setObservaciones] = useState("NA");
  const [marcas, setMarcas] = useState([]);
  const [colecciones, setColecciones] = useState([]);
  const [selectedMarca, setSelectedMarca] = useState("65d8bdeb86de65fdd6715955");
  const [selectedColeccion, setSelectedColeccion] = useState("6451404d3974a90014929a9f");
  const [colores, setColores] = useState([]);
  const [tallas, setTallas] = useState([]);
  const [catalogoProcesos, setCatalogoProcesos] = useState([]);

  // const [colaboradores, setColaboradores] = useState([]);
  // const [selectedVendedor, setSelectedVendedor] = useState("");

  // const [compradores, setCompradores] = useState([]);
  // const [selectedComprador, setSelectedComprador] = useState("");
  // const [clientes, setClientes] = useState([]);
  // const [selectedCliente, setSelectedCliente] = useState("");

  const [departamentos, setDepartamentos] = useState([]);
  const [selectedDepartamento, setSelectedDepartamento] = useState("");
  const [subDepartamentos, setSubDepartamentos] = useState([]);
  const [selectedSubDepartamento, setSelectedSubDepartamento] = useState("");
  // const [clases, setClases] = useState([]);
  // const [selectedClase, setSelectedClase] = useState("");
  // const [subClases, setSubClases] = useState([]);
  // const [selectedSubClase, setSelectedSubClase] = useState("");
  const [empresas, setEmpresas] = useState([]);
  const [selectedEmpresa, setSelectedEmpresa] = useState("");

  const [modalColores, setModalColores] = useState(false);
  const toggleColores = () => setModalColores(!modalColores);
  const [arrayColores, setArrayColores] = useState([]);

  const [modalTallas, setModalTallas] = useState(false);
  const toggleTallas = () => setModalTallas(!modalTallas);
  const [arrayTallas, setArrayTallas] = useState([]);

  const [modalExplosion, setModalExplosion] = useState(false);
  const toggleExplosion = () => setModalExplosion(!modalExplosion);
  const [habilitacion, setHabilitacion] = useState([]);
  const [explosionExistentes, setExplosionExistentes] = useState([]);
  const [codigoExplosion, setCodigoExplosion] = useState("");
  const [idExplosion, setIdExplosion] = useState("");
  const [descripcionExplosion, setDescripcionExplosion] = useState("");
    const [inputFieldsHab, setInputFieldsHab] = useState([
      {
        id: uuidv4(),
        idHab: "",
        cantidad:0
      },
    ]);

  const [modalProcesos, setModalProcesos] = useState(false);
  const toggleProcesos = () => setModalProcesos(!modalProcesos);
  const [arrayProcesos, setArrayProcesos] = useState([
    "6363fb596cdd150aab0461cd",
  ]);

  const [vista, setVista] = useState("Articulo");
  const [validaBoton, setValidaBoton] = useState(true);

  const [dataArtId, setDataArtId] = useState("");

  const [fecha_cancelacion, setFechaCancelacion] = useState("");
  const [fecha_confirmacion, setFechaConfirmacion] = useState("");
  const [total_general, setTotalGeneral] = useState(0);
  const [total_piezas, setTotalPiezas] = useState(0);

  const [arrayProporcion, setArrayProporcion] = useState([]);
  const [arrayTotalColor, setArrayTotalColor] = useState([]);
  const [totalProporcion, setTotalProporcion] = useState(0);
  const [descuento, setDescuento] = useState(0);
  const [precioEtiqueta, setPrecioEtiqueta] = useState(0);
  const [precio, setPrecio] = useState(0);

  const [file, setFile] = useState();
  const [photo, setPhoto] = useState();
  const URL_FILEPOST = process.env.REACT_APP_URL_UPPROFILE;
  const [fichaTecnica, setFichaTecnica] = useState(null);
  const URL_FICHA_POST = process.env.REACT_APP_URL_UPFICHA; // nuevo env

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [telas, setTelas] = useState([]);
  const [explosion, setExplosion] = useState([]);
  const [explosionHab, setExplosionHab] = useState([]);

  const [inputFieldsTela, setInputFieldsTela] = useState([
    {
      id: uuidv4(),
      idTela: "",
      idColor: "",
      cantidad: 0,
      cantidadPrenda: 0,
      observaciones: "NA",
    },
  ]);

  const classes = useStyles();
  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      idColor: "",
      colorNombre: "",
      idTalla: "",
      tallaNombre: "",
      cantidad: 0,
      totalColor: 0,
    },
  ]);

  useEffect(() => {
    axios
      .get(URL_TELAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allTelas = res.data;
        setTelas(allTelas);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_MARCAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allMarcas = res.data;
        setMarcas(allMarcas);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_COLECCIONES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allColecciones = res.data;
        setColecciones(allColecciones);
      })
      .catch((err) => {
        console.log(err);
      });
    // axios
    //   .get(URL_COLORES, {
    //     headers: {
    //       Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    //     },
    //   })
    //   .then((res) => {
    //     const allColores = res.data;
    //     setColores(allColores);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
    axios
      .get(URL_TALLAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allTallas = res.data;
        setTallas(allTallas);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_CATALOGO_PROCESOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allCatalogoProcesos = res.data;
        setCatalogoProcesos(allCatalogoProcesos);
      })
      .catch((err) => {
        console.log(err);
      });
       axios
      .get(URL_HABILITACION, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allHabilitacion = res.data;
        setHabilitacion(allHabilitacion);
      })
      .catch((err) => {
        console.log(err);
      });
    // axios
    //   .get(URL_COLABORADORES, {
    //     headers: {
    //       Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    //     },
    //   })
    //   .then((res) => {
    //     const allColaboradores = res.data;
    //     setColaboradores(allColaboradores);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
    // axios
    //   .get(URL_COMPRADORES, {
    //     headers: {
    //       Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    //     },
    //   })
    //   .then((res) => {
    //     const allCompradores = res.data;
    //     setCompradores(allCompradores);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
    // axios
    //   .get(URL_CLIENTES, {
    //     headers: {
    //       Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    //     },
    //   })
    //   .then((res) => {
    //     const allClientes = res.data;
    //     setClientes(allClientes);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
    axios
      .get(URL_DEPARTAMENTOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allDep = response.data;
        setDepartamentos(allDep);
        //
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_SUBDEPARTAMENTOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allSubDep = response.data;
        setSubDepartamentos(allSubDep);
        //
      })
      .catch((err) => {
        console.log(err);
      });

    // axios
    //   .get(URL_CLASES, {
    //     headers: {
    //       Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    //     },
    //   })
    //   .then((response) => {
    //     let allClase = response.data;
    //     setClases(allClase);
    //     //
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });

    // axios
    //   .get(URL_SUBCLASES, {
    //     headers: {
    //       Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    //     },
    //   })
    //   .then((response) => {
    //     let allSubClase = response.data;
    //     setSubClases(allSubClase);
    //     //
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
    axios
      .get(URL_EMPRESAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allEmpresa = response.data;
        setEmpresas(allEmpresa);
        //
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

function coloresSeleccionados(checked, id) {
  setArrayColores((prev) => {
    if (checked) return Array.from(new Set([...prev, id]));
    return prev.filter((x) => x !== id);
  });
}

function tallasSeleccionados(checked, id) {
  setArrayTallas((prev) => {
    if (checked) return Array.from(new Set([...prev, id]));
    return prev.filter((x) => x !== id);
  });
}

function procesosSeleccionados(checked, id) {
  setArrayProcesos((prev) => {
    if (checked) return Array.from(new Set([...prev, id]));
    return prev.filter((x) => x !== id);
  });
}

const saveArticulos = async (event) => {
  event.preventDefault();
  setValidaBoton(false);

  const headers = {
    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  };

  // helper: guardar explosión SOLO habilitación (POST) para el artículo recién creado
  const saveExplosionHabForArticulo = async (idArticulo) => {
    const habValidas = (inputFieldsHab || []).filter(
      (x) => x?.idHab && String(x.idHab).trim() !== "" && Number(x.cantidad) > 0
    );

    if (!habValidas.length) return; // no hay nada que guardar

    // POSTs en paralelo (si quieres secuencial, te lo cambio)
    await Promise.all(
      habValidas.map((a) =>
        axios.post(
          URL_EXPLOSION,
          {
            articulos: idArticulo,
            habilitacion: a.idHab,
            cantidad: Number(a.cantidad) || 0,
            tipo: "Habilitacion",
          },
          { headers }
        )
      )
    );

    // opcional: log (si lo quieres)
    // await axios.post(
    //   URL_LOGS,
    //   {
    //     tipo: "Agregar Explosion",
    //     detalle: `${idArticulo} Habilitacion`,
    //     user: user.id,
    //   },
    //   { headers }
    // );
  };

  try {
    let tempFoto = file != null ? "Si" : "No";

    const creado = await axios.post(
      URL_ARTICULOS,
      {
        fecha,
        descripcion,
        marcas: selectedMarca,
        colecciones: selectedColeccion,
        colores: arrayColores,
        tallas: arrayTallas,
        catalogoProcesos: arrayProcesos.filter((item, index) => {
          return arrayProcesos.indexOf(item) === index;
        }),
        codigo,
        codigoCliente: codigo,
        departamentos: selectedDepartamento,
        subDepartamentos: selectedSubDepartamento,
        fotoArticulo: tempFoto,
        costo: 0,
        precio: parseFloat(precio) || 0, // L119 — guardar precio de venta en el artículo
        codigoSAT: "NA",
        codigoUnidad: "NA",
      },
      { headers }
    );

    const idNuevoArticulo = creado.data._id;

    // subir foto si aplica (igual que lo tenías)
    if (file != null) {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("articulo", idNuevoArticulo);

      await axios.post(URL_FILEPOST, formData, { headers });
    }
    if (fichaTecnica != null) {
      const formDataFT = new FormData();
      formDataFT.append("file", fichaTecnica);
      formDataFT.append("articulo", idNuevoArticulo);

      await axios.post(URL_FICHA_POST, formDataFT, { headers });
    }


    // traer artículo ya guardado (igual que lo tenías)
    const res = await axios.get(`${URL_ARTICULOS}/${idNuevoArticulo}`, {
      headers,
    });

    const allArticulosGuardado = [res.data];
    setArticulosGuardado(allArticulosGuardado);
    setDataArtId(res.data._id);

    // ========= AQUI: guardar explosión si inputFieldsHab trae info =========
    await saveExplosionHabForArticulo(idNuevoArticulo);

    // lo demás igual (armar arrays)
    const newInputFields2 = [];
    allArticulosGuardado[0].colores.map((a) => {
      allArticulosGuardado[0].tallas.map((b) => {
        newInputFields2.push({
          id: uuidv4(),
          idColor: a._id,
          colorNombre: a.name,
          idTalla: b._id,
          tallaNombre: b.name,
          cantidad: 0,
        });
      });
    });
    setInputFields(newInputFields2);

    const newInputFields3 = [];
    allArticulosGuardado[0].tallas.map((b) => {
      newInputFields3.push({
        id: uuidv4(),
        idTalla: b._id,
        tallaNombre: b.name,
        proporcion: 0,
      });
    });
    setArrayProporcion(newInputFields3);

    const newInputFields4 = [];
    allArticulosGuardado[0].colores.map((b) => {
      newInputFields4.push({
        id: uuidv4(),
        idColor: b._id,
        colorNombre: b.name,
        totalColor: 0,
      });
    });
    setArrayTotalColor(newInputFields4);

    Swal.fire("Good job!", `Creado con exito`, `success`);
    setTimeout(() => {
      window.location.reload();
    }, 2000);
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something went wrong!",
      footer: `${error?.response?.data || error.message}`,
    });
    console.log(error);
    setValidaBoton(true);
  }
};

  const sinVariantes = (t) => !(t?.variantesTallas?.length > 0);


  const isNumericSize = (name) => {
  const s = String(name || "").trim();
  // "18", "20", "22", "10.5" (si existiera). Si quieres SOLO enteros, cambia a /^\d+$/
  return /^\d+(\.\d+)?$/.test(s);
};

const isLetterSize = (name) => {
  const s = String(name || "").trim().toUpperCase();
  // letras + espacios + guiones + puntos (ej: "EXTRA GRANDE", "CH-M", "X.G.")
  return /^[A-ZÁÉÍÓÚÜÑ][A-ZÁÉÍÓÚÜÑ\s.-]*$/.test(s) && !/\d/.test(s);
};


const toggleBatch = (predicate, checked) => {
  const ids = tallas
    .filter((t) => sinVariantes(t) && predicate(t?.name))
    .map((t) => t._id);

  setArrayTallas((prev) => {
    if (checked) return Array.from(new Set([...prev, ...ids]));
    const quitar = new Set(ids);
    return prev.filter((id) => !quitar.has(id));
  });
};

  const handleChangeInputHab = (id, event) => {
    const newInputFieldsHab = inputFieldsHab.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setInputFieldsHab(newInputFieldsHab);
  };
    const handleRemoveFieldsHab = (id) => {
    const values = [...inputFieldsHab];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFieldsHab(values);
  };
    const handleAddFieldsHab = () => {
      setInputFieldsHab([
        ...inputFieldsHab,
        {
          id: uuidv4(),
          idHab: "",
          cantidad:0
        },
      ]);
    };


  return (
    <>
      <Header />
      <br />
      <br />
      {user.articulos_create ? (
        <div className="card container col-11">
          <h3 align="center">Nuevo Articulo</h3>
            <>
              <Form onSubmit={saveArticulos}>
                <Row>
                  {/* <Col md={3}>
                    <Label>Cliente</Label>
                    <Input
                      type="select"
                      value={selectedCliente}
                      onChange={(e) => {
                        setSelectedCliente(e.target.value);
                      }}
                    >
                      <option value="">Selecciona</option>
                      {clientes
                        .sort((a, b) =>
                          a.nombre_comercial > b.nombre_comercial ? 1 : -1
                        )
                        .map((a) => {
                          return (
                            <option value={a._id}>{a.nombre_comercial}</option>
                          );
                        })}
                    </Input>
                  </Col> */}
                  {/* <Col md={3}>
                    <Label className="mr-sm-2">Fecha Cita</Label>
                    <Input
                      type="date"
                      value={fecha}
                      onChange={(e) => {
                        setFecha(e.target.value);
                      }}
                    />
                  </Col> */}
                  <Col md={3}>
                    <Label>Modelo</Label>
                    <Input
                      type="text"
                      placeholder="Codigo"
                      value={codigo}
                      required
                      onChange={(e) => {
                        setCodigo(e.target.value);
                      }}
                    />
                  </Col>
                  <Col md={3}>
                    <Label className="mr-sm-2">Departamento</Label>
                    <Input
                      className="col-sm-12"
                      type="select"
                      value={selectedDepartamento}
                      required
                      onChange={(e) => {
                        setSelectedDepartamento(e.target.value);
                      }}
                    >
                      <option value="0">Selecciona</option>
                      {departamentos
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((a) => {
                          return <option value={a._id}>{a.name}</option>;
                        })}
                    </Input>
                  </Col>
                  <Col md={3}>
                    <Label className="mr-sm-2">Linea</Label>
                    <Input
                      className="col-sm-12"
                      type="select"
                      value={selectedSubDepartamento}
                      required
                      onChange={(e) => {
                        setSelectedSubDepartamento(e.target.value);
                      }}
                    >
                      <option value="0">Selecciona</option>
                      {subDepartamentos
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((a) => {
                          return <option value={a._id}>{a.name}</option>;
                        })}
                    </Input>
                  </Col>
                  {/* <Col md={3}>
                    <Label className="mr-sm-2">Clase</Label>
                    <Input
                      className="col-sm-12"
                      type="select"
                      value={selectedClase}
                      required
                      onChange={(e) => {
                        setSelectedClase(e.target.value);
                      }}
                    >
                      <option value="0">Selecciona</option>
                      {clases
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((a) => {
                          return <option value={a._id}>{a.name}</option>;
                        })}
                    </Input>
                  </Col> */}

                  {/* <Col md={3}>
                    <Label className="mr-sm-2">Etiqueta</Label>
                    <Input
                      className="col-sm-12"
                      type="select"
                      value={selectedSubClase}
                      required
                      onChange={(e) => {
                        setSelectedSubClase(e.target.value);
                      }}
                    >
                      <option value="0">Selecciona</option>
                      {subClases
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((a) => {
                          return <option value={a._id}>{a.name}</option>;
                        })}
                    </Input>
                  </Col> */}
                  <Col md={3}>
                    <Label>Descripcion</Label>
                    <Input
                      type="text"
                      placeholder="Descripcion"
                      value={descripcion}
                      required
                      onChange={(e) => {
                        setDescripcion(e.target.value);
                      }}
                    />
                  </Col>

                  {/* L119 (2026-06) — precio de venta del artículo */}
                  <Col md={3}>
                    <Label className="mr-sm-2">Precio Venta</Label>
                    <Input
                      type="number"
                      step="any"
                      placeholder="Precio Venta"
                      value={precio}
                      onChange={(e) => {
                        setPrecio(e.target.value);
                      }}
                    />
                  </Col>

                  {/* 
                  <Col md={3}>
                    <Label className="mr-sm-2">Vendedor</Label>
                    <Input
                      className="col-sm-12"
                      type="select"
                      value={selectedVendedor}
                      required
                      onChange={(e) => {
                        setSelectedVendedor(e.target.value);
                      }}
                    >
                      <option value="0">Selecciona</option>
                      {colaboradores
                        .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                        .map((a) => {
                          return (
                            <option value={a._id}>
                              {a.nombre} {a.apellido}
                            </option>
                          );
                        })}
                    </Input>
                  </Col> */}
                {/* </Row>
<Row> */}
                    {/* <Col md={3}>
                    <Label className="mr-sm-2">Marca</Label>
                    <Input
                      className="col-sm-12"
                      type="select"
                      value={selectedMarca}
                      required
                      onChange={(e) => {
                        setSelectedMarca(e.target.value);
                      }}
                    >
                      <option value="0">Selecciona</option>
                      {marcas
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((a) => {
                          return <option value={a._id}>{a.name}</option>;
                        })}
                    </Input>
                      </Col>  */}
                       {/* <Col md={3}>
                    <Label className="mr-sm-2">Coleccion</Label>
                    <Input
                      className="col-sm-12"
                      type="select"
                      value={selectedColeccion}
                      required
                      onChange={(e) => {
                        setSelectedColeccion(e.target.value);
                      }}
                    >
                      <option value="0">Selecciona</option>
                      {colecciones
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((a) => {
                          return <option value={a._id}>{a.name}</option>;
                        })}
                    </Input>
                  </Col> */}
                  </Row>
                <Row>
                  {/* <Col md={3}>
                    <Label className="mr-sm-2">Comprador</Label>
                    <Input
                      className="col-sm-12"
                      type="select"
                      value={selectedComprador}
                      required
                      onChange={(e) => {
                        setSelectedComprador(e.target.value);
                      }}
                    >
                      <option value="0">Selecciona</option>
                      {compradores
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((a) => {
                          return <option value={a._id}>{a.name}</option>;
                        })}
                    </Input>
                  </Col> */}
                  {/* <Col md={3}>
                    <Label>Pedido Cliente</Label>
                    <Input
                      type="text"
                      placeholder="Pedido"
                      value={pedido}
                      required
                      onChange={(e) => {
                        setPedido(e.target.value);
                      }}
                    />
                  </Col> */}

                  {/* <Col md={3}>
                    <Label>Modelo Oficial</Label>
                    <Input
                      type="text"
                      placeholder="CodigoCliente"
                      value={codigoCliente}
                      required
                      onChange={(e) => {
                        setCodigoCliente(e.target.value);
                      }}
                    />
                  </Col> */}
                  {/* <Col md={3}>
                    <Label>CodigoSAT</Label>
                                    <Input
                                      type="select"
                                      placeholder="CodigoSAT"
                                      value={codigoSAT}
                                      required
                                      onChange={(e) => {
                                        setCodigoSAT(e.target.value);
                                      }}
                                    >
                                      <option value="">Selecciona</option>
                                      <option value="53101604">53101604 Blusas Mujer</option>
                                      <option value="53102002">
                                        53102002 Vestidos, Faldas, Jumper
                                      </option>
                                      <option value="53101504">53101504 Pantalones Mujer</option>
                                      <option value="53101804">53101804 Chamarras Mujer</option>
                                      <option value="53101704">53101704 Sweater Mujer</option>
                                      <option value="53103100">53103100 Chalecos</option>
                                      <option value="53102800">53102800 Trajes de Baño</option>
                                      <option value="53101602">53101602 Camisas Hombre</option>
                                      <option value="53101502">53101502 Pantalon Hombre</option>
                                      <option value="52121500">52121500 Cobija</option>
                                      <option value="52121509">52121509 Sabanas</option>
                                      <option value="53102606">53102606 Batas de Baño</option>
                                      <option value="52121701">52121701 Toallas de Baño</option>
                                      <option value="24122003">24122003 Botellas de cristal</option>
                                    </Input>
                  </Col> */}
                  {/* <Col md={3}>
                    <Label className="mr-sm-2">Descuento</Label>
                    <Input
                      // bsSize="sm"
                      name="descuento"
                      type="number"
                      placeholder="Descuento"
                      value={descuento}
                      required
                      onChange={(e) => {
                        setDescuento(e.target.value);
                      }}
                    />
                  </Col> */}

                  {/* <Col md={3}>
                    <Label>Observaciones Diseño</Label>
                    <Input
                      type="textarea"
                      placeholder="Observaciones"
                      value={observaciones}
                      required
                      onChange={(e) => {
                        setObservaciones(e.target.value);
                      }}
                    />
                  </Col> */}
                </Row>

                <Row>
                {/*  <Col md={2}>
                    <Label for="exampleEmail" className="mr-sm-2">
                      Agregar Colores
                    </Label>
                    <br />
                    <Button
                      color="success"
                      id="Colores"
                      onClick={(e) => toggleColores()}
                    >
                      <i class="fas fa-palette fa-2x "></i>
                    </Button>
                  </Col> */}

                  <Col md={2}>
                    <Label for="exampleEmail" className="mr-sm-2">
                      Agregar Tallas
                    </Label>
                    <br />
                    <Button
                      color="success"
                      id="Tallas"
                      onClick={(e) => toggleTallas()}
                    >
                      <i class="fas fa-ruler-horizontal fa-2x "></i>
                    </Button>
                  </Col>
                  <Col md={2}>
                    <Label for="exampleEmail" className="mr-sm-2">
                      Agregar Explosion
                    </Label>
                    <br />
                    <Button
                      color="success"
                      id="Explosion"
                      onClick={(e) => toggleExplosion()}
                    >
                      <i class="fas fa-tag fa-2x "></i>
                    </Button>
                  </Col>

                  {/* <Col md={2}>
                    <Label for="exampleEmail" className="mr-sm-2">
                      Agregar Procesos
                    </Label>
                    <br />
                    <Button
                      color="success"
                      id="Procesos"
                      onClick={(e) => toggleProcesos()}
                    >
                      <i class="fas fa-tshirt fa-2x "></i>
                    </Button>
                  </Col> */}
                  <Col md={4}>
                    <Label>Foto</Label>
                    <Input
                      type="file"
                      onChange={(e) => {
                        setFile(e.target.files[0]);
                      }}
                    />
                  </Col>

                  <Col md={4}>
                    <Label>Ficha Técnica</Label>
                    <Input
                      type="file"
                      onChange={(e) => {
                        setFichaTecnica(e.target.files[0]);
                      }}
                    />
                  </Col>
                </Row>
                <br />
                {validaBoton ? (
                  <Button type="submit" className="btn btn-success">
                    Guardar
                  </Button>
                ) : (
                  <Button type="submit" className="btn btn-success" disabled>
                    Guardar
                  </Button>
                )}
                <Button
                  href="/ListadoArticulos"
                  className="btn btn-danger"
                  id="botonListado"
                >
                  Regresar
                </Button>
              </Form>
            </>

          <br />

          <Modal size="lg" isOpen={modalColores} toggle={toggleColores}>
            <ModalHeader toggle={toggleColores}>
              <h4>Colores del Modelo {nombre}</h4>
            </ModalHeader>
            <ModalBody>
              {colores
                .sort((a, b) => (a.name > b.name ? 1 : -1))
                .map((a, index) => {
                  if (!arrayColores.includes(a._id)) {
                    return (
                      <table>
                        <td>
                          <Input
                            type="checkbox"
                            key={index}
                            onChange={(e) => {
                              coloresSeleccionados(
                                e.currentTarget.checked,
                                a._id
                              );
                            }}
                            className="subMenu"
                          />
                          <h5 className="subMenuTitulo">{a.name}</h5>
                        </td>
                      </table>
                    );
                  } else {
                    return <h5 className="subMenuTitulo">{a.name}</h5>;
                  }
                })}
            </ModalBody>
          </Modal>

<Modal size="lg" isOpen={modalTallas} toggle={toggleTallas}>
  <ModalHeader toggle={toggleTallas}>
    <h4>Tallas del Modelo {nombre}</h4>
  </ModalHeader>

  <ModalBody>
    <div className="d-flex gap-2 mb-3">
      <button
        type="button"
        className="btn btn-sm btn-success"
        onClick={() => toggleBatch(isNumericSize, true)}
      >
        Seleccionar numéricas
      </button>

      <button
        type="button"
        className="btn btn-sm btn-success"
        onClick={() => toggleBatch(isLetterSize, true)}
      >
        Seleccionar Alfa
      </button>

      <button
        type="button"
        className="btn btn-sm btn-dark"
        onClick={() => toggleBatch(isNumericSize, false)}
      >
        Quitar numéricas
      </button>

      <button
        type="button"
        className="btn btn-sm btn-dark"
        onClick={() => toggleBatch(isLetterSize, false)}
      >
        Quitar Alfa
      </button>
    </div>

    {tallas
      .filter((a) => !a.variantesTallas || a.variantesTallas.length === 0)
      .sort((a, b) => (a.idTalla > b.idTalla ? 1 : -1))
      .map((a) => {
        const variante = a.variantesTallas?.[0];
        const checked = arrayTallas.includes(a._id);

        return (
          <div key={a._id} className="d-flex align-items-center gap-2 mb-2">
            <Input
              type="checkbox"
              checked={checked}
              onChange={(e) => tallasSeleccionados(e.currentTarget.checked, a._id)}
            />
            <span className="subMenuTitulo">
              {a.name} {variante?.name || ""}
            </span>
          </div>
        );
      })}
  </ModalBody>
</Modal>



          <Modal size="lg" isOpen={modalProcesos} toggle={toggleProcesos}>
            <ModalHeader toggle={toggleProcesos}>
              <h4>Procesos del Modelo {nombre}</h4>
            </ModalHeader>
            <ModalBody>
              {catalogoProcesos
                // .sort((a, b) => (a.name > b.name ? 1 : -1))
                .map((a, index) => {
                  if (a._id != "6363fb596cdd150aab0461cd") {
                    return (
                      <table>
                        <td>
                          <Input
                            type="checkbox"
                            key={index}
                            onChange={(e) => {
                              procesosSeleccionados(
                                e.currentTarget.checked,
                                a._id
                              );
                            }}
                            className="subMenu"
                          />
                          <h5 className="subMenuTitulo">{a.name}</h5>
                        </td>
                      </table>
                    );
                  } else {
                    return <h5 className="subMenuTitulo">{a.name}</h5>;
                  }
                })}
            </ModalBody>
          </Modal>

          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                {" "}
                Este proceso puede tardar varios minutos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>


      <Modal size="lg" isOpen={modalExplosion} toggle={toggleExplosion}>
        <ModalHeader toggle={toggleExplosion}>
          <h4>
            Explosion
          </h4>
        </ModalHeader>
        <ModalBody>

        <Row>
            <Col md={6}>
            <Label>Habilitacion</Label>
            </Col>
            <Col md={3}>
            <Label>Cantidad</Label>
            </Col>
          </Row>
          {inputFieldsHab.map((a)=>(
            <div key={a.id}>
              <Row>
              <Col md={6}>
                      <Input
                        bsSize="sm"
                        name="idHab"
                        type="select"
                        value={a.idHab}
                        required
                        onChange={(event)=>{handleChangeInputHab(a.id, event)}}
                      >
                        <option value="">Selecciona</option>
                        {habilitacion
                          .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                          .map((a) => {
                            return (
                              <option value={a._id}>
                                {a.nombre} {a.descripcion}
                              </option>
                            );
                          })}
                      </Input>
                    </Col>
                    <Col md={3}>
                        <Input
                         bsSize="sm"
                          name="cantidad"
                          type="number"
                          value={a.cantidad}
                          onChange={(event)=>{handleChangeInputHab(a.id, event)}}
                        >
                        </Input>
                      </Col>
                      <Col>
                      <Button
                        size="sm"
                        className="btn"
                        color="danger"
                        disabled={inputFieldsHab.length === 1}
                        onClick={() => handleRemoveFieldsHab(a.id)}
                        tabindex="-1"
                      >
                        <i class="fas fa-minus"></i>
                      </Button>
                      <Button 
                      size="sm"
                      className="btn"
                      color="info"
                      onClick={handleAddFieldsHab}
                      tabindex="-1">
                      <i class="fas fa-plus"></i>
                      </Button>
                    </Col>
              </Row>
            </div>
          ))}
      </ModalBody>
      </Modal>


        </div>
      ) : undefined}
    </>
  );
}

export default ArticulosCreateSolo;
